import React, { useState } from "react";
import SectionHeader from "@/components/SectionHeader";
import { QuickReadCategory, QuickReadsComponent } from "@/components/PageHome/api/interface";
import { fetchArticlesAPI } from "@/components/PageHome/api";
import { DeviceInfo } from "@/interface/deviceInfo";
import ArticleInfo from "@/components/ArticleInfo";
import { FILTER_MAPPING } from "@/helpers/constants";
import { getResourceListingURL } from "@/helpers";
import styles from "./Article.module.scss";

interface ArticleProps {
  data: QuickReadsComponent;
  userAgent: DeviceInfo;
  assetPosition?: number;
  pageCategory?: string;
  firstFoldData?: any;
}

const Article: React.FC<ArticleProps> = ({ data, userAgent, assetPosition, pageCategory, firstFoldData }) => {
  const { Title, Description, Categories, articles: initialArticles } = data;
  const categories = Categories?.data;

  const [activeCategory, setActiveCategory] = useState<string>(categories?.[0]?.attributes.Slug);
  const [articles, setArticles] = useState(initialArticles);

  const handleTabChange: (slug: string) => void = async (slug) => {
    try {
      const response = await fetchArticlesAPI(slug);

      if (response?.length) {
        setArticles(response);
      } else {
        setArticles([]);
      }
    } catch (err) {
      console.error(err);
      setArticles([]);
    }

    setActiveCategory(slug);
  };

  return (
    <section className={`${styles.root} spacingBetweenSections`}>
      <div className={"container"}>
        <SectionHeader title={Title} subTitle={Description} userAgent={userAgent} />

        {!!categories?.length && (
          <div className={styles.tabsWrapper}>
            {categories.map(({ id, attributes }: QuickReadCategory) => {
              const { CategoryName, Slug } = attributes;
              const isActive = activeCategory === Slug;

              return (
                <button
                  type={"button"}
                  onClick={() => handleTabChange(Slug)}
                  key={id}
                  className={`${styles.tab} ${isActive ? styles.active : ""}`}
                >
                  {CategoryName}
                </button>
              );
            })}
          </div>
        )}

        {/*TODO: add href, PRD does not mention where to take user to (probably  it should go to general article listing) */}
        {/* I’m trying to conceive journey: If the user clicks on this button, then the user will land on the article listing page of Pre-conception category*/}
        {/* My baby is on the way journey: If the user clicks on this button, then the user will land on the article listing page of the particular week of pregnancy*/}
        {/* I’m about to deliver journey: If the user clicks on this button, then the user will land on the article listing page of the particular week of pregnancy*/}
        {/* I’m new mother journey: If the user clicks on this button, then the user will land on the article listing page of the particular month of childhood*/}
        {/* If the child age >12 months: If the user clicks on this button, then the user will land on the article listing page of toddler category*/}
        {/*TODO: For above case need slug of cluster [1 month, 2 month, etc]*/}
        <ArticleInfo
          desktopItems={3}
          articles={articles}
          userAgent={userAgent}
          ctaURL={getResourceListingURL({ [FILTER_MAPPING.category]: [activeCategory || pageCategory] }, "articles")}
          sectionTitle={Title}
          assetPosition={assetPosition}
        />
      </div>
    </section>
  );
};

export default Article;
